import { LANGUAGES } from "@app/shared/constants/localization.constants";
import { AbstractAdapter } from "@app/shared/models/adapter.model";
import { Field } from "@app/shared/models/form-field.model";

export enum viewStates {
  viewSettings,
  viewTranslationsList,
  viewTranslationForm
}

export interface ComponentOverridesSettings {
  roleId?: Field;
  menuId?: Field;
  componentId: Field;
  content: Field;
}

export interface ComponentOverridesLanguageList {
  componentId: string;
  componentsList: ComponentOverridesLanguageListComponentsList[];
}

export interface ComponentOverridesLanguageListComponentsList {
  language: string;
  content: string;
  _language?: string;
  isSelected?: boolean;
  isDeleted?: boolean;
}

export interface ComponentOverridesLanguageSettings {
  componentId: string;
  language: Field;
  content: Field;
}

/**
 * Class: ComponentOverridesSettingsAdapter
 *
 * Implements a data adapter for component overrides
 */
export class ComponentOverridesSettingsAdapter extends AbstractAdapter<ComponentOverridesSettings> {
  adapt(rawData: any): ComponentOverridesSettings {
    return rawData;
  }
}

/**
 * Class: ComponentOverridesLanguageListAdapter
 *
 * Implements a data adapter for component overrides
 */
export class ComponentOverridesLanguageListAdapter extends AbstractAdapter<ComponentOverridesLanguageList> {
  adapt(rawData: any): ComponentOverridesLanguageList {
    (rawData?.componentsList as ComponentOverridesLanguageListComponentsList[])?.map((e) => {
      e._language = e.language === LANGUAGES.ENGLISH.value ? this.translate("APP.LBL_ENGLISH") : this.translate("APP.LBL_SPANISH");
      e.isSelected = false;
      return e;
    });
    return rawData;
  }
}

/**
 * Class: ComponentOverridesLanguageSettingsAdapter
 *
 * Implements a data adapter for component overrides translations
 */
export class ComponentOverridesLanguageSettingsAdapter extends AbstractAdapter<ComponentOverridesLanguageSettings> {
  adapt(rawData: any): ComponentOverridesLanguageSettings {
    return rawData;
  }
}
